import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Paper,
  Divider,
  Button,
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ py: { xs: 4, md: 8 }, backgroundColor: 'background.default' }}>
      <Container maxWidth="md">
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/')}
          sx={{ mb: 3 }}
        >
          Back to Home
        </Button>
        <Paper sx={{ p: { xs: 3, md: 6 } }}>
          <Typography variant="h3" component="h1" gutterBottom>
            Privacy Policy
          </Typography>
          
          <Typography variant="body2" color="text.secondary" paragraph>
            Last updated: {new Date().toLocaleDateString()}
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom>
            1. Information We Collect
          </Typography>
          <Typography paragraph>
            TNCOSOFT ("we," "our," or "us") collects information you provide directly to us, such as when you:
          </Typography>
          <Box component="ul" sx={{ pl: 3, mb: 3 }}>
            <Typography component="li" paragraph>Contact us through our website forms</Typography>
            <Typography component="li" paragraph>Request infrastructure assessments or services</Typography>
            <Typography component="li" paragraph>Subscribe to our communications</Typography>
            <Typography component="li" paragraph>Engage with our IT infrastructure solutions</Typography>
          </Box>

          <Typography variant="h5" gutterBottom>
            2. How We Use Your Information
          </Typography>
          <Typography paragraph>
            We use the information we collect to:
          </Typography>
          <Box component="ul" sx={{ pl: 3, mb: 3 }}>
            <Typography component="li" paragraph>Provide IT infrastructure services and support</Typography>
            <Typography component="li" paragraph>Respond to your inquiries and requests</Typography>
            <Typography component="li" paragraph>Send you technical updates and infrastructure alerts</Typography>
            <Typography component="li" paragraph>Improve our services and website functionality</Typography>
            <Typography component="li" paragraph>Comply with legal obligations and industry standards</Typography>
          </Box>

          <Typography variant="h5" gutterBottom>
            3. Information Sharing and Disclosure
          </Typography>
          <Typography paragraph>
            We do not sell, trade, or otherwise transfer your personal information to third parties except:
          </Typography>
          <Box component="ul" sx={{ pl: 3, mb: 3 }}>
            <Typography component="li" paragraph>With your explicit consent</Typography>
            <Typography component="li" paragraph>To trusted service providers who assist in our operations</Typography>
            <Typography component="li" paragraph>When required by law or to protect our rights</Typography>
            <Typography component="li" paragraph>In connection with our technology partnership services</Typography>
          </Box>

          <Typography variant="h5" gutterBottom>
            4. Data Security
          </Typography>
          <Typography paragraph>
            As an IT infrastructure company, we implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. We use industry-standard encryption and security protocols.
          </Typography>

          <Typography variant="h5" gutterBottom>
            5. Data Retention
          </Typography>
          <Typography paragraph>
            We retain your personal information only for as long as necessary to fulfill the purposes outlined in this policy, comply with legal obligations, resolve disputes, and enforce our agreements.
          </Typography>

          <Typography variant="h5" gutterBottom>
            6. Your Rights
          </Typography>
          <Typography paragraph>
            You have the right to:
          </Typography>
          <Box component="ul" sx={{ pl: 3, mb: 3 }}>
            <Typography component="li" paragraph>Access your personal information</Typography>
            <Typography component="li" paragraph>Correct inaccurate information</Typography>
            <Typography component="li" paragraph>Request deletion of your information</Typography>
            <Typography component="li" paragraph>Object to processing of your information</Typography>
            <Typography component="li" paragraph>Request data portability</Typography>
          </Box>

          <Typography variant="h5" gutterBottom>
            7. Cookies and Tracking
          </Typography>
          <Typography paragraph>
            Our website may use cookies and similar tracking technologies to enhance user experience and analyze website performance. You can control cookie settings through your browser preferences.
          </Typography>

          <Typography variant="h5" gutterBottom>
            8. Third-Party Services
          </Typography>
          <Typography paragraph>
            Our website may contain links to third-party services, including our technology partner platforms. This privacy policy does not apply to third-party websites or services.
          </Typography>

          <Typography variant="h5" gutterBottom>
            9. International Data Transfers
          </Typography>
          <Typography paragraph>
            Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place for such transfers.
          </Typography>

          <Typography variant="h5" gutterBottom>
            10. Changes to This Policy
          </Typography>
          <Typography paragraph>
            We may update this privacy policy from time to time. We will notify you of any material changes by posting the new policy on our website.
          </Typography>

          <Typography variant="h5" gutterBottom>
            11. Contact Information
          </Typography>
          <Typography paragraph>
            If you have questions about this privacy policy or our data practices, please contact us at:
          </Typography>
          <Box sx={{ pl: 2, mb: 3 }}>
            <Typography paragraph><strong>TNCOSOFT</strong></Typography>
            <Typography paragraph>Email: njinabad@tncosoft.com</Typography>
            <Typography paragraph>Phone: +91-8999096807</Typography>
          </Box>

          <Divider sx={{ my: 3 }} />
          
          <Typography variant="body2" color="text.secondary">
            This privacy policy is effective as of {new Date().toLocaleDateString()} and governs the collection and use of information by TNCOSOFT.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;